import { useState } from "react";
import ReactCrop    from "react-image-crop";

import { PrimaryButton } from "_components/atoms/button";
import Typography        from "_components/atoms/typography";

import useStyles from "./styles";

import "react-image-crop/dist/ReactCrop.css";

const component = props => {
	const [ image, setImage ] = useState ( null );

	let result64;

	const { rawImageData, onImageDrop, fromUserSettings } = props;
	const [ crop, setCrop ]                               = useState ( { unit: "%", width: 100, aspect: fromUserSettings ? 1 : 16 / 9 } );
	const { classes }                                     = useStyles ( undefined, { name: "styles" } );

	const getCroppedImg = () => {
		const canvas = document.createElement ( "canvas" );
		const scaleX = image.naturalWidth / image.width;
		const scaleY = image.naturalHeight / image.height;

		canvas.width  = crop.width;
		canvas.height = crop.height;

		const ctx = canvas.getContext ( "2d" );

		ctx.drawImage ( image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height );

		const base64Image = canvas.toDataURL ( `image/${ rawImageData.imageType }` );

		result64 = base64Image;

		return new Promise ( resolve => {
			canvas.toBlob (
				blob => {
					blob.name = `newFile.${ rawImageData.imageType }`;
					resolve ( blob );
				},
				`image/${ rawImageData.imageType }`,
				1
			);
		} );
	};

	const onSave = async () => {
		const croppedImg = await getCroppedImg ();

		const { handleImageUpload } = props;

		const payloadObj = {
			purchased : true,
			src       : result64,
			blobFile  : croppedImg
		};

		handleImageUpload ( payloadObj );
	};

	return (
		<div>
			{
				rawImageData && (
					<div>
						<ReactCrop
							crop          = { crop }
							onChange      = { setCrop }
							onImageLoaded = { setImage }
							src           = { rawImageData.imageData }
						/>

					</div>
				)
			}

			<div className = { classes.sliderContainer }>
				{fromUserSettings ? (
					<div className = { classes.reselectSaveCtn }>

						<PrimaryButton
							className = { classes.submitBtn }
							onClick   = { onSave }
							title     = "Update"
						/>

						{/* <Button
							className = { classes.submitBtn }
							color     = "secondary"
							onClick   = { onSave }
							variant = "filled"
						>
							<Typography className = "textSecondary fontBold"
								variant = "body1"
							>
								Update
							</Typography>
						</Button> */}
					</div>
				) : (
					<div className = { classes.reselectSaveCtn }>
						<div className = { classes.reselectButton }
							onClick       = { onImageDrop }
						>

							<Typography
								className = { `${ classes.reselectButtonText } fontBold` }
								title     = "Reselect"

							/>
						</div>

						<PrimaryButton
							className = { classes.submitBtn }
							onClick   = { onSave }
							size      = "small"
							title     = "Save"

						/>

					</div>
				)}
			</div>
		</div>
	);
};

export default component;
